
export const CALIBRATION_KEYS = {
  flow: 'flow-calibration-data',
  pressureAdvance: 'pressure-advance-calibration-data'
} as const;

export const PREFERENCE_KEYS = {
  slicer: 'preferred-slicer',
  calculatorMode: 'preferredCalculatorMode'
} as const;

export interface CalibrationMetadata {
  completed: boolean;
  completedAt: string;
  slicerUsed: string;
}

export type SlicerType = "creality" | "orca" | "anycubic";

// Calibration type mapping for analytics
export const CALIBRATION_ANALYTICS_TYPES = {
  [CALIBRATION_KEYS.flow]: 'flow_rate',
  [CALIBRATION_KEYS.pressureAdvance]: 'pressure_advance'
} as const;
